


































































































import {
  CARD_HEIGHT,
  getBannerConfig,
  getDisplayCouponList,
  initPullUpLoadObj,
  INVALID_AREA_MARGIN,
  INVALID_AREA_TEXT,
  LAYOUT_TOP,
} from '@/api/displayCoupon/display-coupon';
import { FitLayout, FitWxPhonex } from '@tencent/wphk-ui';
import {
  getQryType,
  listOnClickCouponTypeInExpirePage,
  pageConfigStore,
} from '@/business/display-coupon-record';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import debounce from '@/util/debounce';
import { util, windowHelper, language } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import Vue from 'vue';
import { Route } from 'vue-router';
import VueBetterScroll from 'vue2-better-scroll';
import {
  COUPON_QRY_TYPE,
  loadBannerConfig,
} from '../api/displayCoupon/display-coupon';
import { i18n } from '@/i18n';
import {
  isNotStart,
  listOnClickCouponTypeInValidPage,
} from '../business/display-coupon-record';
import DisplayCounponLink from '@/components/display-counpon-link/index.vue';
import { parseHK$Aria } from '@tencent/wphk-act-base-ui';

const initData = {
  invalidCouponText: INVALID_AREA_TEXT,
  list: [],
  showList: false,
  couponList: [],
  hasMore: true,
  loadingDone: false,
  // 下拉组件配置
  // 这个配置可以开启滚动条，默认为 false。当设置为 true 或者是一个 Object 的时候，都会开启滚动条，默认是会 fade 的
  scrollbarObj: false,
  // scrollbarObj: {
  // fade: true,
  // },
  // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
  pullDownRefreshObj: false,
  // pullDownRefreshObj: {
  //   threshold: 90,
  //   stop: 40,
  // },
  // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
  pullUpLoadObj: initPullUpLoadObj,
  startY: 0, // 纵轴方向初始化位置
  scrollToX: 0,
  scrollToY: 0,
  scrollToTime: 700,
};
export default Vue.extend({
  components: {
    VueBetterScroll,
    FitWxPhonex,
    FitLayout,
    DisplayCounponLink,
  },
  name: 'displaycouponlist',
  data() {
    return { data: { ...initData }, bannerConfig: {} as any };
  },
  computed: {
    isEn() {
      return language.isEn();
    },
  },
  async created() {
    document.title = i18n('手動啟用券');
    pageConfigStore.reset(getQryType(this.$route.query.type));
    await this.getDisplayCouponList();

    this.isInvalidCouponPage()
      ? biHT('promotion.merchantcoupon.usedlist.page_brow')
      : biHT('promotion.merchantcoupon.home.page_brow');
    // 下架营销banner
    // await loadBannerConfig();
    // this.bannerConfig = getBannerConfig();
  },
  watch: {
    $route: {
      handler(to: Route, from: Route) {
        if (from && from.path === '/displaycouponlist') {
          this.data = { ...initData };
          pageConfigStore.reset(getQryType(this.$route.query.type));
          this.getDisplayCouponList();
          document.title = this.isInvalidCouponPage()
            ? i18n('已用及失效商戶電子優惠券')
            : i18n('手動啟用券');
          this.isInvalidCouponPage()
            ? biHT('promotion.merchantcoupon.usedlist.page_brow')
            : biHT('promotion.merchantcoupon.home.page_brow');
        }
      },
      immediate: true,
    },
  },
  methods: {
    parseHK$Aria,
    i18n,
    isNotStart,
    navToHref() {
      const link = this.bannerConfig.smallBannerLink;
      if (link) {
        windowHelper.redirect(link, 300);
      }
    },
    clickAct() {
      const link = this.bannerConfig.bigBannerLink;
      if (link) {
        windowHelper.redirect(link, 300);
      }
    },
    getNoRecordText() {
      return this.isInvalidCouponPage()
        ? i18n('暫時沒有已失效的商戶電子優惠券')
        : i18n('暫無商戶電子優惠券');
    },
    isInvalidCouponPage() {
      return this.$route.query.type === COUPON_QRY_TYPE.INVALID;
    },
    isListOverflow() {
      return (
        this.data.couponList.length * CARD_HEIGHT >
        window.innerHeight - LAYOUT_TOP - INVALID_AREA_MARGIN
      );
    },
    onPullingUp() {
      this.getDisplayCouponList();
    },
    async getDisplayCouponList() {
      if (!this.data.hasMore) {
        const scrollRef = this.$refs.scroll;
        scrollRef && (scrollRef as any).forceUpdate(this.data.hasMore); // 如果加载完了就不再加载了？
      } else {
        showLoading();
        const [err, res] = await util.to(getDisplayCouponList());
        this.data.loadingDone = true;
        hideLoading();
        if (err) {
          showBusinessError(err);
          throw new Error(err);
        }
        const { data: couponList, hasMore } = res;
        this.data.hasMore = hasMore;
        this.data.couponList = this.data.couponList.concat(couponList);
        this.data.showList = this.data.couponList.length > 0;
        const scrollRef = this.$refs.scroll;
        scrollRef && (scrollRef as any).forceUpdate(this.data.hasMore); // false ：加载完了；true:未加载完
        if (this.data.hasMore && couponList.length === 0) {
          // 这里为了失效券列表要做调整，如果hasMore为true但是length为0说明全部都被filter掉了
          this.getDisplayCouponList();
        }
      }
    },
    goDetail(coupon) {
      this.isInvalidCouponPage()
        ? biHT('promotion.merchantcoupon.usedlist.details_click', {
            fspcouponid: coupon.couponId,
            type: listOnClickCouponTypeInExpirePage(coupon),
          })
        : biHT('promotion.merchantcoupon.home.details_click', {
            type: listOnClickCouponTypeInValidPage(coupon),
            fspcouponid: coupon.couponId,
          });
      this.$router.push({
        name: 'displaycoupondetail',
        query: { userScid: coupon.userScid },
      });
    },
    handleTouchMove(e: TouchEvent) {
      // 无列表数据时禁止页面滑动
      if (!this.data.showList) {
        e.preventDefault();
      }
    },
  },
});
